(() => {
 const navigation=window.performance?.getEntriesByType?.('navigation')?.[0];
 if(navigation?.type!=='reload'||window.Shopify?.designMode||!document.querySelector('[data-lens-finder]')||new URLSearchParams(window.location.search).get('edit_lens')==='1')return;
 const previous=window.history.scrollRestoration;
 window.history.scrollRestoration='manual';
 if(window.location.hash)window.history.replaceState(window.history.state,'',window.location.pathname+window.location.search);
 const reset=()=>{
  window.scrollTo({top:0,left:0,behavior:'instant'});
  window.requestAnimationFrame(()=>{
   window.scrollTo({top:0,left:0,behavior:'instant'});
   window.history.scrollRestoration=previous;
  });
 };
 if(document.readyState==='complete')reset();
 else window.addEventListener('pageshow',reset,{once:true});
})();
(() => {
 function initialize(){
  document.querySelectorAll('[data-lens-finder]').forEach(finder=>{
   if(finder.dataset.ready){finder.sllRefreshFlow?.();return;}
   finder.dataset.ready='true';
   const fields=Object.fromEntries(['style','model','shape','color'].map(key=>[key,finder.querySelector('[data-step="'+key+'"]')]));
   const cards=[...finder.querySelectorAll('[data-lens-card]')];
   const results=finder.querySelector('[data-finder-results]');
   const status=finder.querySelector('[data-finder-summary]');
   const modelOptions=[...fields.model.options].map(option=>option.cloneNode(true));
   const shapeOptions=[...fields.shape.options].map(option=>option.cloneNode(true));
   let pendingShape='';
   let syncFlow=()=>{};
   const split=value=>(value||'').split(/[\n,]+/).map(value=>value.trim()).filter(Boolean);
   const rules=[...finder.querySelectorAll('[data-lens-rule]')].map(element=>({
    product:element.dataset.product,shape:element.dataset.shape,color:element.dataset.color,
    styles:split(element.dataset.styles),models:split(element.dataset.models)
   }));
   const label=key=>fields[key].selectedOptions[0]?.textContent||'';
   const eligible=()=>rules.filter(rule=>rule.styles.includes(fields.style.value)&&rule.models.includes(fields.model.value)&&rule.shape===fields.shape.value);
   function models(){
    fields.model.replaceChildren(...modelOptions.filter(option=>!option.value||(option.dataset.frameStyle?option.dataset.frameStyle===fields.style.value:fields.style.value==='unknown')).map(option=>option.cloneNode(true)));
    fields.model.value='';
   }
   function shapes(preferred=fields.shape.value){
    const available=new Set(rules.filter(rule=>rule.styles.includes(fields.style.value)&&rule.models.includes(fields.model.value)).map(rule=>rule.shape));
    fields.shape.replaceChildren(...shapeOptions.filter(option=>!option.value||available.has(option.value)).map(option=>option.cloneNode(true)));
    fields.shape.value=available.has(preferred)?preferred:'';
   }
   function colors(){
    const previous=fields.color.value;
    const available=[...new Set(eligible().map(rule=>rule.color))].sort((a,b)=>a.localeCompare(b));
    fields.color.replaceChildren(new Option(finder.dataset.colorPrompt,''));
    available.forEach(color=>fields.color.add(new Option(color==='Clear'?(finder.dataset.clearLabel||'Clear'):color,color)));
    if(available.includes(previous))fields.color.value=previous;
   }
   function update(){
    fields.model.disabled=!fields.style.value;
    fields.shape.disabled=fields.model.disabled||!fields.model.value||fields.shape.options.length<2;
    fields.color.disabled=fields.shape.disabled||!fields.shape.value||fields.color.options.length<2;
    const complete=!fields.color.disabled&&!!fields.color.value;
    const products=new Set(eligible().filter(rule=>rule.color===fields.color.value).map(rule=>rule.product));
    const exact=complete&&products.size===1?[...products][0]:null;
    let count=0;
    cards.forEach(card=>{
     const match=!!exact&&card.dataset.product===exact&&card.dataset.shape===fields.shape.value&&card.dataset.color===fields.color.value&&count===0;
     card.hidden=!match;
     if(match)count++;
    });
    results.hidden=count!==1;
    const values={count,shape:label('shape'),color:label('color'),style:label('style'),model:label('model')};
    status.textContent=!fields.style.value?finder.dataset.statusStyle:
     !fields.model.value?finder.dataset.statusModel:
     !fields.shape.value?(fields.shape.options.length<2?finder.dataset.statusUnconfirmed:finder.dataset.statusShape):
     fields.color.options.length<2||(complete&&count!==1)?finder.dataset.statusUnconfirmed:
     !complete?finder.dataset.statusColor:
     finder.dataset.statusResults.replace(/\[(count|shape|color|style|model)\]/g,(_,key)=>values[key]).replace(/^1 listings\b/,'1 listing');
    syncFlow();
   }
   cards.forEach(card=>card.querySelectorAll('a').forEach(link=>link.addEventListener('click',()=>{
    if(card.hidden||!fields.style.value||!fields.model.value||!fields.shape.value||!fields.color.value)return;
    const selection={product:card.dataset.product,style:fields.style.value,model:fields.model.value,shape:fields.shape.value,shapeLabel:label('shape'),color:fields.color.value,at:Date.now()};
    try{sessionStorage.setItem('sll-order-selection',JSON.stringify(selection));}catch{}
   })));
   Object.entries(fields).forEach(([key,field])=>field.addEventListener('change',()=>{
    if(key==='style'){models();pendingShape='';shapes('');fields.color.value='';colors();}
    if(key==='model'){shapes(fields.shape.value||pendingShape);pendingShape='';fields.color.value='';colors();}
    if(key==='shape'){fields.color.value='';colors();}
    update();
   }));
   finder.querySelector('[data-finder-reset]').addEventListener('click',()=>{
    Object.values(fields).forEach(field=>field.value='');
    fields.style.value='Big C';models();pendingShape='';shapes('');colors();update();fields.style.focus({preventScroll:true});
   });
   finder.sllPick=(kind,value)=>{
    if(kind==='frame'){
     fields.style.value=({'C Decor / Wood':'C Decor','Piccadilly / Small C':'Piccadilly'})[value]||value;
     if(!fields.style.value)fields.style.value='unknown';
     models();pendingShape='';shapes('');fields.color.value='';colors();update();
    }else{
     if(!fields.style.value){fields.style.value='unknown';models();}
     if(fields.style.value==='unknown'&&!fields.model.value)fields.model.value='unknown';
     pendingShape=fields.model.value?'':value;shapes(value);fields.color.value='';colors();update();
     (fields.color.disabled?fields.model:fields.color).focus({preventScroll:true});
    }
   };
   fields.style.value=finder.hasAttribute('data-continuous-flow')?'':'Big C';models();shapes('');colors();
   if(new URLSearchParams(window.location.search).get('edit_lens')==='1'){
    try{
     const saved=JSON.parse(sessionStorage.getItem('sll-order-selection')||'null');
     if(saved&&Date.now()-saved.at<7200000){
      fields.style.value=saved.style;models();fields.model.value=saved.model;shapes(saved.shape);colors();fields.color.value=saved.color;
     }
    }catch{}
   }
   if(finder.hasAttribute('data-continuous-flow')){
    finder.sllRefreshFlow=()=>{syncFlow=setupFlow(finder,fields,rules,cards,results);syncFlow();};
    syncFlow=setupFlow(finder,fields,rules,cards,results);
   }
   update();
  });
 }

 function setupFlow(finder,fields,rules,cards,results){
  const modelPanel=document.querySelector('[data-frame-model-panel]');
  const explorer=document.querySelector('[data-shape-explorer]');
  if(!modelPanel||!explorer)return ()=>{};
  finder.sllFlowAbort?.abort();
  finder.sllFlowAbort=new AbortController();
  const on=(element,name,handler)=>element.addEventListener(name,handler,{signal:finder.sllFlowAbort.signal});
  finder.querySelectorAll('.sll-flow-context,.sll-flow-colors').forEach(element=>element.remove());
  finder.dataset.continuous='true';explorer.dataset.continuous='true';
  const model=modelPanel.querySelector('[data-flow-model]');
  const selectedFrame=modelPanel.querySelector('[data-selected-frame]');
  const next=modelPanel.querySelector('[data-model-continue]');
  const otherPanel=document.querySelector('[data-other-frame-panel]');
  const other=otherPanel.querySelector('[data-other-frame]');
  const frameCards=[...document.querySelectorAll('[data-frame-pick]')];
  const shapeCards=[...explorer.querySelectorAll('[data-flow-shape]')];
  const context=document.createElement('div');context.className='sll-flow-context';
  const summary=document.createElement('p');context.append(summary);
  for(const [text,href]of [['Change frame / model','#frame-model'],['Change lens shape','#lens-shapes']]){
   const a=document.createElement('a');a.textContent=text;a.href=href;context.append(a);
  }
  const colors=document.createElement('div');colors.className='sll-flow-colors';
  colors.setAttribute('role','group');colors.setAttribute('aria-label',fields.color.labels[0]?.textContent||'Lens color');
  finder.querySelector('.sll-finder-controls').before(context,colors);
  const aliases={'C Decor / Wood':'C Decor','Piccadilly / Small C':'Piccadilly'};
  const cardStyles=new Set(frameCards.map(a=>aliases[a.dataset.framePick]||a.dataset.framePick));
  other.replaceChildren(...[...fields.style.options].filter(o=>!o.value||!cardStyles.has(o.value)).map(o=>o.cloneNode(true)));
  other.value='';otherPanel.hidden=other.options.length<2;
  on(other,'change',()=>{if(!other.value)return;finder.sllPick('frame',other.value);go(modelPanel);});
  on(model,'change',()=>{fields.model.value=model.value;fields.model.dispatchEvent(new Event('change',{bubbles:true}));});
  on(next,'click',()=>go(explorer));
  let colorKey='';
  const canonical=value=>value.toLowerCase().replace(/gradient|\s|\//g,'');
  function go(element){element.scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});}
  function sync(){
   modelPanel.hidden=!fields.style.value;
   other.value=cardStyles.has(fields.style.value)?'':fields.style.value;
   model.replaceChildren(...[...fields.model.options].map(o=>o.cloneNode(true)));model.value=fields.model.value;model.disabled=fields.model.disabled;
   selectedFrame.textContent=fields.style.selectedOptions[0]?.textContent||'';
   next.disabled=!fields.model.value||fields.shape.options.length<2;
   frameCards.forEach(a=>a.setAttribute('aria-current',String((aliases[a.dataset.framePick]||a.dataset.framePick)===fields.style.value)));
   shapeCards.forEach(card=>{
    const mapped=[...fields.shape.options].some(o=>o.value===card.dataset.flowShape);
    card.hidden=!!fields.model.value&&!mapped;
    const button=card.querySelector('[data-explore-colors]');
    if(!button.dataset.previewPanel)button.dataset.previewPanel=button.getAttribute('aria-controls');
    button.setAttribute('aria-controls',finder.id);button.removeAttribute('aria-expanded');
    button.setAttribute('aria-pressed',String(fields.shape.value===card.dataset.flowShape));
    button.querySelector('.sll-explore-label').textContent=fields.model.value?'Choose this shape →':'Choose your frame model first →';
   });
   const parts=[fields.style.value,fields.model.value,fields.shape.selectedOptions[0]?.value?fields.shape.selectedOptions[0].textContent:''].filter(Boolean);
   summary.textContent=parts.join(' · ');
   context.hidden=!fields.style.value;
   const key=[fields.style.value,fields.model.value,fields.shape.value,...[...fields.color.options].map(o=>o.value)].join('|');
   if(key!==colorKey){
    colorKey=key;colors.replaceChildren();
    const shapeCard=shapeCards.find(card=>card.dataset.flowShape===fields.shape.value);
    const panel=shapeCard?document.getElementById(shapeCard.querySelector('[data-explore-colors]').dataset.previewPanel):null;
    for(const option of fields.color.options){
     if(!option.value||fields.color.disabled)continue;
     const button=document.createElement('button');button.type='button';button.className='sll-flow-color';button.dataset.color=option.value;button.setAttribute('aria-pressed','false');
     const preview=[...(panel?.querySelectorAll('figure')||[])].find(figure=>canonical(figure.querySelector('figcaption').textContent)===canonical(option.value));
     const exact=rules.find(rule=>rule.styles.includes(fields.style.value)&&rule.models.includes(fields.model.value)&&rule.shape===fields.shape.value&&rule.color===option.value);
     const source=preview?.querySelector('img')||cards.find(card=>card.dataset.product===exact?.product)?.querySelector('img');
     if(source){const img=source.cloneNode(true);img.removeAttribute('id');img.alt=(fields.shape.selectedOptions[0]?.textContent||'Lens')+' — '+option.textContent;button.append(img);}
     const label=document.createElement('span');label.textContent=option.textContent;button.append(label);
     on(button,'click',()=>{fields.color.value=option.value;fields.color.dispatchEvent(new Event('change',{bubbles:true}));if(!results.hidden)go(results);});
     colors.append(button);
    }
   }
   colors.hidden=fields.color.disabled;
   colors.querySelectorAll('button').forEach(button=>button.setAttribute('aria-pressed',String(button.dataset.color===fields.color.value)));
  }
  on(explorer,'click',event=>{
   const button=event.target.closest('[data-explore-colors]');
   if(!button)return;
   event.preventDefault();
   if(!fields.model.value){go(fields.style.value?modelPanel:document.getElementById('frame-styles'));return;}
   const shape=button.closest('[data-flow-shape]').dataset.flowShape;
   finder.sllPick('shape',shape);go(finder);
  });
  on(finder.querySelector('[data-finder-reset]'),'click',()=>{fields.style.value='';fields.style.dispatchEvent(new Event('change',{bubbles:true}));go(document.getElementById('frame-styles'));});
  return sync;
 }

 document.addEventListener('click',event=>{
  const target=event.target.closest('[data-frame-pick],[data-shape-pick]');
  if(!target)return;
  const finder=document.querySelector('[data-lens-finder]');
  if(!finder)return;
  initialize();
  const frame=target.hasAttribute('data-frame-pick');
  finder.sllPick(frame?'frame':'shape',target.dataset.framePick||target.dataset.shapePick);
  if(frame&&finder.dataset.continuous==='true'){
   event.preventDefault();
   document.querySelector('[data-frame-model-panel]').scrollIntoView({behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'start'});
  }
 });
 initialize();
 document.addEventListener('shopify:section:load',initialize);
})();
